import Advertising from "./Advertising";

export * from "./Advertising";

export default Advertising;
